var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalance28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.352 11.66C2 12.442 2 13.39 2 15.285v4.2c0 2.384 0 3.576.487 4.47a4.047 4.047 0 0 0 1.929 1.76c.935.404 2.102.297 4.435.082 1.768-.162 3.606-.347 5.149-.537 2.041-.252 4.544-.638 6.734-.997 1.84-.3 2.759-.451 3.474-.925a4.048 4.048 0 0 0 1.44-1.695c.352-.782.352-1.73.352-3.627v-4.201c0-2.382 0-3.574-.487-4.468a4.048 4.048 0 0 0-1.928-1.76c-.935-.403-2.1-.297-4.432-.084-1.77.162-3.61.347-5.153.537-2.042.252-4.546.639-6.737.999-1.838.301-2.757.452-3.472.926a4.048 4.048 0 0 0-1.44 1.695ZM7 19.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.007 6.985c.467-.209.933-.35 1.384-.461.664-.163 1.453-.293 2.292-.43l.093-.016c2.203-.361 4.754-.756 6.857-1.015 1.589-.196 3.464-.384 5.247-.547l.11-.01c1.07-.098 2.058-.189 2.89-.192.903-.004 1.893.087 2.894.519.139.06.275.124.41.193-.29-.379-.646-.71-1.044-.962-.74-.468-1.68-.594-3.56-.847-2.013-.27-4.25-.544-6.08-.703-1.498-.13-3.28-.23-4.988-.306-2.214-.099-3.322-.148-4.216.273-.773.364-1.438.999-1.836 1.755-.343.652-.43 1.448-.453 2.749Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance28);
export default __webpack_public_path__ + "static/media/balance_28.08c3b2ab.svg";
export { ForwardRef as ReactComponent };